import { ListSymptomResponse, PermissionBit } from "../../../api";
import { AccessRules } from "../../../constants/roles";
import { DataModel } from "../../../models/data-model";

export class Symptoms extends DataModel<SymptomsItem> {
  readonly idAttr = "uuid";

  constructor(
    data: SymptomsItem[],
    permissions: PermissionBit[],
    userUUID: string,
  ) {
    super(data, permissions, userUUID);
    this.hasHistory = true;

    // access
    this.access = {
      editRules: {
        medical: AccessRules.owner,
        monitoring: AccessRules.visible,
      },
      deleteRules: {
        medical: AccessRules.none,
        monitoring: AccessRules.visible,
      },
      historyRequiresMonitoring: true,
    };
  }
}

export type SymptomsItem = ListSymptomResponse["symptoms"][number];
